import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wishlistSolidWhite",
  "use": "wishlistSolidWhite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"wishlistSolidWhite\"><path d=\"m11.89 22.519 8.493-9.283-.033-.036.676-.677c.067-.066.132-.134.196-.204 2.37-2.59 2.37-6.824 0-9.415-2.323-2.539-6.05-2.539-8.373 0-.065.07-.127.142-.188.215l-.734.876-.776-.848c-2.323-2.54-6.05-2.54-8.373 0-2.37 2.59-2.37 6.823 0 9.414z\" fill=\"#fff\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol